// Animates every [data-countup] number from 0 to its server-rendered value
// once it scrolls into view (donation totals: [allDonations] /
// [openDonationTotal]). The real value is already in the DOM, so browsers
// without JS/IntersectionObserver simply keep the static number.
export default function () {

    const numbers = document.querySelectorAll('[data-countup]');
    if (!numbers.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) return;

    // Mirror the server's format: plain number, comma as decimal separator.
    function format(value, decimals) {
        return decimals
            ? value.toFixed(decimals).replace('.', ',')
            : String(Math.round(value));
    }

    function animate(el) {
        const raw = String(el.dataset.countup);
        const target = parseFloat(raw.replace(',', '.')) || 0;
        const decimals = /[.,]\d+/.test(raw) ? 2 : 0;
        const duration = 1800;
        let start = null;

        el.classList.add('is-counting');

        function step(now) {
            if (start === null) start = now;
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 4);

            el.textContent = format(target * eased, decimals);

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.classList.remove('is-counting');
                el.classList.add('is-counted');
            }
        }

        requestAnimationFrame(step);
    }

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                animate(entry.target);
            }
        });
    }, { threshold: 0.5 });

    numbers.forEach(function (el) {
        el.textContent = '0';
        observer.observe(el);
    });
}
